import RegionalCommonUtils from "@/core/utils/regional/RegionalCommonUtils";

class EsUtils {

  /**
   * Валидирует испанский NIF (Número de Identificación Fiscal)
   * @param {string} value - NIF для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateNIF(value) {
    if (typeof value !== 'string') return null;
    if (value.length !== 12) return 'N.I.F. должен быть 12 символов длиной';
    if (!/(ES-[A-Z]|\d)\d{7}([A-Z]|\d)/g.test(value)) return 'Некорректный N.I.F.';
    if (value.split('').filter(letter => /[A-Z]/.test(letter)).length !== 3) {
      return 'Некорректный N.I.F.';
    }
    return null;
  }

  static validateLEI = RegionalCommonUtils.validateLEI;
}

export default EsUtils;
